import React, { Component } from 'react';
import { shape, object, array } from 'prop-types';
import BlockUser from '@fiverr-private/block_user';
import Reviews from '@fiverr-private/reviews';
import InfoPanel from './InfoPanel';
import StickyProfile from './StickyProfile';
import Gigs from './Gigs';
import {
    buildSellerCardData,
    buildPortfolioData,
    buildFiverrLearnData,
    buildProSubCategories
} from './lib/dataBuilder';
import reportEvent from './lib/reportEvent';
import { triggerMixPanelEvent, Events } from './lib/mixpanelEvents';
import './index.scss';
import '@fiverr-private/block_user/dist/index.css';
import '@fiverr-private/reviews/dist/index.css';

const { VIEWED_PAGE, INTERACTED, VIEWED_SELLER_PORTFOLIO, CLICKED_CONTACT_ME } = Events.GeneralEvents;
const showReviews = (reviewsObject) => (!!(reviewsObject && reviewsObject.reviews && reviewsObject.reviews.length));

export default class Index extends Component {
    componentDidMount() {
        const { requestContext, userData, gigs, gigIds } = this.props;
        const { current_user } = requestContext;

        const {
            id: sellerId,
            country,
            member_since,
            response_time,
            recent_delivery,
            is_seller
        } = userData.seller_card.user;

        const { courses } = userData;
        const userId = current_user && current_user.id || null;
        const type = is_seller ? 'seller_page.show' : 'users.show';

        reportEvent(type, { userId, sellerId, gigIds });

        const avarage_response_time = response_time > 0 ? { 'Avarage response time': response_time } : {};

        triggerMixPanelEvent(VIEWED_PAGE, userData, gigs.gigs, {
            'Seller Country': country,
            'Member since': new Date(member_since * 1000).getFullYear(),
            'Learn courses': courses.filter((course) => course.progression_status === 3).length,
            'Recent delivery': recent_delivery,
            ...avarage_response_time
        });

        // User-page-V2 hooks init
        global.fUserPagePerseus && global.fUserPagePerseus.init();
    }

    handleFilterChange = (filterType) => {
        const { userData, gigs } = this.props;

        const mixPanelAction = ({
            'all': 'Filter most recent',
            'positive': 'Filter positive reviews',
            'negative': 'Filter negative reviews'
        })[filterType];

        triggerMixPanelEvent(INTERACTED, userData, gigs.gigs, { Action: mixPanelAction });
    }

    handlePortfolioClick = () => {
        const { userData, gigs } = this.props;
        triggerMixPanelEvent(VIEWED_SELLER_PORTFOLIO, userData, gigs.gigs, {});
    }

    handleContactClick = () => {
        const { requestContext } = this.props;
        const { current_user } = requestContext;
        const { userData, gigs, gigIds } = this.props;
        const { id: sellerId } = userData.seller_card.user;
        const userId = current_user.id;

        reportEvent('seller_page.contact_me', { userId, sellerId, gigIds });
        triggerMixPanelEvent(CLICKED_CONTACT_ME, userData, gigs.gigs, {});
    }

    scroll = (comp) => {
        this[comp].scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    render() {
        const { requestContext, viewObject, gigs, userData, analyticsData } = this.props;
        const { page_ctx_id: pageCtxId, current_user = {}, params = {}, ab_tests: abTests } = requestContext;
        const { user_id: sellerName } = params;
        const { currency, is_viewer_studio_lead: isViewerStudioLead } = viewObject;
        const currentUserId = current_user.id || null;
        const {
            user, courses, pro_badge,
            seller_profile, buying_reviews, selling_reviews,
            interaction_block, portfolio_projects
        } = userData;

        const sellerCardData = buildSellerCardData({ requestContext, userData, currency, abTests, gigs, analyticsData, isViewerStudioLead });
        const portfolioProjects = buildPortfolioData(portfolio_projects, user);
        const fiverrLearnCourses = buildFiverrLearnData(courses);
        const proSubCategories = buildProSubCategories(pro_badge);
        const skillTests = seller_profile.passed_seller_tests;

        const showBuyingReviews = showReviews(buying_reviews);
        const showSellingReviews = showReviews(selling_reviews);
        const isBlocked = interaction_block && interaction_block.current_user_blocking;
        const { is_seller, has_live_gigs, id: userNumberedId } = sellerCardData.user;
        const userHasGigs = is_seller || has_live_gigs;

        const reviewsBaseConfig = {
            pageCtxId,
            pageName: 'user_page',
            biEventGroup: 'seller_page'
        };

        const buyingReviews = {...reviewsBaseConfig, ...buying_reviews};
        const sellingReviews = {...reviewsBaseConfig, ...selling_reviews};

        const scrollToData = [
            { ref: 'gigRef', title: 'gigs', scrollFunc: this.scroll },
            { ref: 'reviewsRef', title: 'reviews', scrollFunc: this.scroll }
        ];

        return (
            <div className="user-page-perseus">
                <StickyProfile contactClick={this.handleContactClick}
                    sellerCard={sellerCardData}/>

                <BlockUser isBlocked={isBlocked}
                    userId={userNumberedId}
                    username={sellerName}/>

                <div className="content">
                    <InfoPanel proSubCategories={proSubCategories}
                        currentUserNumberedId={currentUserId}
                        pageCtxId={pageCtxId}
                        sellerCard={sellerCardData}
                        scrollComponents={scrollToData}
                        portfolioProjects={portfolioProjects}
                        fiverrLearnCourses={fiverrLearnCourses}
                        sellerProfile={seller_profile}
                        skillTests={skillTests}
                        onPortfolioClick={(location) => this.handlePortfolioClick(location)}/>

                    <div className="gigs-panel" ref={(ref) => this.gigRef = ref}>
                        {userHasGigs &&
                            <Gigs gigData={gigs}
                                userId={currentUserId}
                                sellerName={sellerName}
                                pageCtxId={pageCtxId}
                                currency={currency}
                                abTestsProps={abTests}/>}

                        <div ref={(ref) => this.reviewsRef = ref}/>

                        {showBuyingReviews && <Reviews initialState={buyingReviews}
                            onFilterChange={(type) => this.handleFilterChange(type)}
                            onLoadMoreClick={() => triggerMixPanelEvent(INTERACTED, userData, gigs.gigs, { Action: 'Load more' })}/>}

                        {showSellingReviews && <Reviews initialState={sellingReviews}
                            onFilterChange={(type) => this.handleFilterChange(type)}
                            onLoadMoreClick={() => triggerMixPanelEvent(INTERACTED, userData, gigs.gigs, { Action: 'Load more' })}/>}
                    </div>
                </div>
            </div>
        );
    }
}

Index.propTypes = {
    requestContext: shape({
        ab_tests: object
    }),
    viewObject: shape({
        currency: object
    }),
    gigs: shape({
        gigs: array
    }),
    analyticsData: shape({
        response_time: object
    }),
    userData: shape({
        user: object,
        seller_card: object,
        seller_profile: object,
        portfolio_projects: array,
        courses: array,
        pro_badge: object,
        buying_reviews: object,
        selling_reviews: object,
        interaction_block: object
    })
};

Index.defaultProps = {
    requestContext: {},
    viewData: {},
    viewObject: {
        currency: {
            name: 'USD',
            rate: '1',
            symbol: '$'
        }
    }
};
